import { Provider } from 'jotai';
import type { ReactNode } from 'react';
import { useComponentStore, usePageStore } from './hooks';

interface JotaiProviderProps {
  id: string;
  children: ReactNode;
}

export const ComponentJotaiProvider = ({
  children,
  id,
}: JotaiProviderProps) => {
  const store = useComponentStore(id);
  return <Provider store={store}>{children}</Provider>;
};

interface PageJotaiProviderProps {
  children: ReactNode;
}

export const PageJotaiProvider = ({ children }: PageJotaiProviderProps) => {
  const pageStore = usePageStore();
  return <Provider store={pageStore}>{children}</Provider>;
};
